/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Play_Store_IdInputs */

const en_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store Account`)
};

const ar_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حساب متجر جوجل بلاي`)
};

const de_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store-Konto`)
};

const es_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta de la tienda de Google Play`)
};

const fr_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte Google Play Store`)
};

const it_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account del Play Store Google`)
};

const ja_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Playストアアカウント`)
};

const ko_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play 스토어 계정`)
};

const pt_br_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta Google Play Store`)
};

const ru_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунт Google Play Store`)
};

const th_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชี Google Play Store`)
};

const tr_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store Hesabı`)
};

const zh_cn_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store 账号`)
};

const zh_tw_google_play_store_id = /** @type {(inputs: Google_Play_Store_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Play Store 帳號`)
};

/**
* | output |
* | --- |
* | "Google Play Store Account" |
*
* @param {Google_Play_Store_IdInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const google_play_store_id = /** @type {((inputs?: Google_Play_Store_IdInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Play_Store_IdInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_google_play_store_id(inputs)
	if (locale === "ar") return ar_google_play_store_id(inputs)
	if (locale === "de") return de_google_play_store_id(inputs)
	if (locale === "es") return es_google_play_store_id(inputs)
	if (locale === "fr") return fr_google_play_store_id(inputs)
	if (locale === "it") return it_google_play_store_id(inputs)
	if (locale === "ja") return ja_google_play_store_id(inputs)
	if (locale === "ko") return ko_google_play_store_id(inputs)
	if (locale === "pt_br") return pt_br_google_play_store_id(inputs)
	if (locale === "ru") return ru_google_play_store_id(inputs)
	if (locale === "th") return th_google_play_store_id(inputs)
	if (locale === "tr") return tr_google_play_store_id(inputs)
	if (locale === "zh_cn") return zh_cn_google_play_store_id(inputs)
	return zh_tw_google_play_store_id(inputs)
});